import { manageUpdateAccessObj } from "../../features/manageUpdateAccess/manageUpdateAccessTypes";
import { Action, otpPopupState } from "../../types"

export const initialPopupState:otpPopupState = {
    isOpen:false,
    onSuccess:(verifiedUser?: manageUpdateAccessObj)=>{},
    allowedUsers: []
}
export function validateOtpPopupReducer(state:otpPopupState=initialPopupState,action:Action<otpPopupState>):otpPopupState{
    switch(action.type){
        case "setOtpPopupState":
            return {...state,...action.payload};
        case "closeOtpPopup":
            return initialPopupState
    }
    return state
}